<script lang="ts" setup>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const initAni = () => {
  const gTimeLine = gsap.timeline()
  gTimeLine
    .fromTo(
      '.section__pic, .section__pic__mask',
      {
        width: '100%',
        height: '100vh',
        marginLeft: '0'
      },
      {
        width: '39%',
        height: '37%',
        marginLeft: '10%',
        scrollTrigger: {
          trigger: '.section',
          start: 'top',
          end: 'bottom',
          scrub: true,
          pin: true
        }
      }
    )
    .fromTo(
      '.section__content',
      {
        opacity: 1
      },
      {
        opacity: 0,
        scrollTrigger: {
          trigger: '.section__content',
          start: 'top',
          end: 'bottom',
          scrub: true
        }
      }
    )
    .fromTo(
      '.section2',
      {
        top: '100%'
      },
      {
        top: 0,
        scrollTrigger: {
          trigger: '.section',
          start: 'top',
          end: 'bottom',
          scrub: true
        }
      }
    )
}

onMounted(() => {
  useImagesLoaded('.section__pic img').then(initAni)
})
</script>

<template>
  <section class="section">
    <figure class="section__pic">
      <div class="section__pic__mask"></div>
      <Nimg src="./images/career/main.jpg" />
    </figure>
    <div class="section__content">
      <div class="section__title">
        讓我們一起創造未來的<br />
        無限想像
      </div>
      <div class="section__text">
        我們做的不只是一份工作，<br />
        而是一趟實踐自我的精彩旅程
      </div>
    </div>
    <div class="section__content2">
      <div class="section__content2__inner">
        <div class="section__content2__subtitle">career</div>
        <div class="section__content2__title">人才發展</div>
        <div class="section__content2__text">
          恆隆行專注於人才培育及專業能力的養成，讓每一個人依照個人特質與專長，在管理或專業領域中獲取良好的發展。
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.section {
  position: relative;
  margin-top: toRem(-66);

  &__pic {
    width: 100%;

    &__mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: calc(100vh - toRem(88));
      background-color: rgba(0, 0, 0, 0.2);
    }

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__content {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    height: calc(100vh - toRem(88));
    color: $color-white-1;
  }

  &__title {
    margin-bottom: toRem(55);
    font-size: toRem(52);
    font-weight: 500;
    line-height: 1.3;

    @include max-media(880) {
      font-size: toRem(32);
    }
  }

  &__text {
    font-size: toRem(20);
    font-weight: 500;
    line-height: 1.4;

    @include max-media(880) {
      font-weight: 700;
      font-size: toRem(16);
      line-height: 1.6;
    }
  }
}

.section__content2 {
  position: relative;
  z-index: 5;
  width: 100%;
  @include grid;

  @include max-media(990) {
    @include grid(4, 24);
  }

  &__inner {
    grid-column: 7 / span 4;

    @include max-media(990) {
      grid-column: 2 / span 3;
    }
  }

  &__subtitle {
    font-size: toRem(158);
    font-weight: 500;
    line-height: 0.8;
    margin-bottom: toRem(24);
    font-family: $font-TextaAlt;
    color: $color-gray-3;

    @include max-media(880) {
      font-size: toRem(80);
    }
  }

  &__title {
    font-size: toRem(28);
    font-weight: 500;
    line-height: 1.3;
    margin-bottom: toRem(20);
  }

  &__text {
    font-size: toRem(20);
    font-weight: 500;
    line-height: 1.4;

    @include max-media(880) {
      font-size: toRem(16);
    }
  }
}
</style>
